import React from 'react';

const HorizontalRule = () => <hr />;

export default HorizontalRule;
